import * as React from 'react';
import clsx from 'clsx';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { ElementDimensions } from '../../styles/ElementDimensions'

const useStyles = makeStyles({
    logoContainer: {
        textAlign: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingTop: ElementDimensions.padding10 + 'px',
        paddingBottom: ElementDimensions.padding10 + 'px',
    },
    logoContainerLandscape: {
        textAlign: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    logoImage: {
        maxHeight: ElementDimensions.logoHeight + 'px',
    }
});

const RestaurantLogo = () => {
    const isPortrait = useMediaQuery('(orientation: portrait)');
    const [logoUrl, setLogoUrl] = React.useState<string>('');
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    React.useEffect(() => {
        setLogoUrl(checkOutState.state.restaurantLogoUrl === null ? '' : checkOutState.state.restaurantLogoUrl);
    }, [checkOutState.state.restaurantLogoUrl]);
    
    return (
        <div className={clsx({
            [classes.logoContainer]: isPortrait,
            [classes.logoContainerLandscape]: !isPortrait,
        })}>
            {logoUrl !== '' &&
                <img src={logoUrl} className={classes.logoImage}></img>
            }
        </div>
    );
}

export default RestaurantLogo;